import React from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'hooks/useWindowSize'
import { ICONS } from '../globals'
const Container = styled.div<{
  pos: { x: number; y: number }
  type: 'left' | 'right' | 'middle'
}>`
  z-index: 1000;
  position: absolute;
  left: ${props => props.pos.x}px;
  top: ${props => props.pos.y}px;
  transform: ${props =>
    props.type === 'middle'
      ? 'translateX(-50%)'
      : props.type === 'right'
      ? 'translateX(-100%)'
      : 'translateX(0)'};

  width: 300px;
  max-width: 300px;
  @media only screen and (max-width: 750px) {
    left: -1em;
    transform: translateX(0);
    width: calc(100% + 2em);
    max-width: initial;
  }

  display: inline-block;

  background-color: #fff;

  font-family: var(--chart-font-stack);
  padding: 0.5em;
  -webkit-box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.08);
  box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.08);
`
const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
  text-align: center;
  padding-top: 1em;
`
const PropTable = styled.table`
  font-size: 12px;
  td {
    border-bottom: 1px solid #eee;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  tr:last-of-type {
    td {
      border: 0;
    }
  }
`
const Swatch = styled.div<{ color: string }>`
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background-color: ${props => props.color};
`

const CantonsValue = styled.td`
  text-align: right;
  padding-left: 0.5em;
  font-weight: 700;
  font-size: 15px;
  vertical-align: top;
`
const IndicatorDesc = styled.td`
  line-height: 0;
  padding-left: 0.5em;
  svg,
  div {
    float: left;
  }
  div {
    max-width: calc(100% - 50px);
  }
`

const IndicatorName = styled.span`
  display: inline-block;
  width: 100%;
  color: #000;
  font-size: 12px;
  line-height: 1.3em;
`
const IndicatorUnit = styled.span`
  display: inline-block;
  width: 100%;
  color: #888;
  line-height: 1.4em;
  font-size: 12px;
`
export const Tooltip = ({
  data,
  pos,
  locale = 'DE',
  indicators,
  nodataLabel
}: {
  data: drawdataType
  pos: { x: number; y: number }
  locale?: 'DE' | 'FR'
  indicators: indicatorDataType[]
  nodataLabel: string
}) => {
  const size = useWindowSize()
  const type =
    pos.x < size.width * 0.2
      ? 'left'
      : pos.x > size.width * 0.8
      ? 'right'
      : 'middle'
  return (
    <Container pos={pos} type={type}>
      <Title>{locale === 'DE' ? data.namede : data.namefr}</Title>
      <PropTable>
        <tbody>
          {indicators.map(indicator => {
            if (
              !data.data[indicator.id].abs &&
              data.data[indicator.id].abs !== 0
            )
              return (
                <tr>
                  <td colSpan={2}>
                    <IndicatorUnit>{nodataLabel} </IndicatorUnit>
                  </td>
                  <IndicatorDesc>
                    <svg width='40' height='40'>
                      <IndicatorIcon
                        d={ICONS[indicator.id]}
                        transform='translate(20,20)scale(1.6)'
                      />
                    </svg>
                    <div>
                      <IndicatorName>
                        {locale === 'DE'
                          ? indicator.name_de
                          : indicator.name_fr}
                      </IndicatorName>
                      <IndicatorUnit>
                        {locale === 'DE'
                          ? indicator.unit_de
                          : indicator.unit_fr}
                      </IndicatorUnit>
                    </div>
                  </IndicatorDesc>
                </tr>
              )
            return (
              <tr>
                <td style={{ verticalAlign: 'top' }}>
                  <Swatch color={data.data[indicator.id].color || '#000'} />
                </td>
                <CantonsValue>
                  {data.data[indicator.id].abs.toFixed(
                    data.data[indicator.id].abs ===
                      Math.round(data.data[indicator.id].abs)
                      ? 0
                      : 1
                  )}
                </CantonsValue>
                <IndicatorDesc>
                  <svg width='40' height='40'>
                    <IndicatorIcon
                      d={ICONS[indicator.id]}
                      transform='translate(20,20)scale(1.6)'
                    />
                  </svg>
                  <div>
                    <IndicatorName>
                      {locale === 'DE' ? indicator.name_de : indicator.name_fr}
                    </IndicatorName>
                    <IndicatorUnit>
                      {locale === 'DE' ? indicator.unit_de : indicator.unit_fr}
                    </IndicatorUnit>
                  </div>
                </IndicatorDesc>
              </tr>
            )
          })}
        </tbody>
      </PropTable>
    </Container>
  )
}

const IndicatorIcon = styled.path`
  fill: #202346;
`
